import OurPartner from 'components/common/OurPartner';
import { BsArrowRightCircle } from 'react-icons/bs';

const TakeCareEvent = ({ data }) => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'DE EVENTE take care',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  return (
    <section className='DBlock bg-eventLightPink'>
      <div className='max-w-7xl mx-auto'>
        <OurPartner data={data} titleDetail={titleDetail} />
        <div className='DBlock px-6 sm:px-10 pb-10 sm:pb-12'>
          <div className='max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 bg-white border-2 border-eventLGray rounded-xl shadow-sm p-5 sm:p-8'>
            <img
              className='shadow-lg w-full'
              src='/assets/images/about-us/takecare.png'
              alt='takecareImg'
            />
            <div className='flex flex-col justify-around'>
              <div>
                <img src='/assets/images/common/spotify.png' alt='spotify' />
              </div>
              <p className='text-eventGray text-sm sm:text-base font-light py-6'>
                Higher education in the era of the industrial revolution 4.0
                requires breakthrough learning using digital platforms that
                answer the challenges of millennial students to study anywhere,
                anytime and with leading-edge ICT technology. From student
                recruitment to teaching and learning administration processes,
              </p>
              <hr className='h-0.5 mb-4' />
              <div className='flex items-center justify-between'>
                <div>
                  <h2 className='text-lg font-semibold text-black'>
                    Briana Patton
                  </h2>
                  <p className='text-sm text-eventGray'>
                    Designer at Salesforce
                  </p>
                </div>
                <BsArrowRightCircle className='sm:text-4xl text-3xl cursor-pointer text-eventGray' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TakeCareEvent;
